import React from "react";

function BracesAligners() {
  return <div>BracesAligners</div>;
}

export default BracesAligners;
